function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.588 2.889a3.667 3.667 0 11-5.186 5.186 3.667 3.667 0 015.186-5.186M21.225 14.383a3.661 3.661 0 11-5.178 5.178 3.661 3.661 0 015.178-5.178M7.953 14.383a3.661 3.661 0 11-5.178 5.178 3.661 3.661 0 015.178-5.178",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.419 7.727A7.663 7.663 0 116.582 18.564 7.663 7.663 0 0117.419 7.727",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));